// Case list page translation (new version card style)
export default {
  // Page title and version switch
  pageTitle: "Analysis - Case Analysis",
  switchToOldVersion: "Switch to Old Version",
  switchToNewVersion: "Switch to New Version",

  // Header operation area
  header: {
    updateTime: "Update Time",
    selectPlaceholder: "Please select",
    searchPlaceholder: "Please enter {label}",
    createCase: "Create Case",
  },

  // Search type options
  searchTypes: {
    name: "Case Name",
    caseType: "Case Type",
    createUserName: "Creator",
  },

  // Card content
  card: {
    edit: "Edit",
    delete: "Delete",
    canvasCount: "[Canvas Count]",
    surveyUser: "[Survey Users]",
    surveySuggests: "[Survey Suggestions]",
    updateTime: "Update Time",
    viewDetail: "View Details",
  },

  // Footer pagination
  footer: {
    total: "Total",
    totalUnit: "records",
  },

  // Confirm dialog
  confirmDialog: {
    deleteTitle: "Confirmation",
    deleteMessage:
      "This operation will permanently delete the case {caseName}, are you sure?",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
  },

  // Message prompts
  messages: {
    deleteSuccess: "Deleted successfully!",
    deleteCancelled: "Deletion cancelled",
  },
};
